"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegionButton = void 0;

var tslib_1 = require("tslib");

var ui_button_1 = require("@hopin-team/ui-button");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.RegionButton = (0, styled_components_1.default)(ui_button_1.Button).attrs({
  isInline: true,
  isOutlined: true,
  trailingIcon: 'caret-down'
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 0;\n  padding-left: ", ";\n  background-color: ", ";\n\n  &:hover {\n    border-right: 0;\n  }\n\n  ", " {\n    margin-left: ", ";\n    color: ", ";\n  }\n"], ["\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 0;\n  padding-left: ", ";\n  background-color: ", ";\n\n  &:hover {\n    border-right: 0;\n  }\n\n  ", " {\n    margin-left: ", ";\n    color: ", ";\n  }\n"])), (0, ui_symbols_1.calcSpace)(2), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY[200]', theme);
}, ui_icon_1.Icon, (0, ui_symbols_1.calcSpace)(2), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY[600]', theme);
});
var templateObject_1;